<template>
  <div style="padding: 10px">
    <el-form :model="busData" label-width="150px" :rules="rules">
      <el-form-item label="报销开始日期：" required>
        <el-date-picker v-model="busData.start_date" type="date" placeholder="开始日期" style="width: 100%"></el-date-picker>
      </el-form-item>

      <el-form-item label="报销结束日期：" required>
        <el-date-picker v-model="busData.end_date" type="date" placeholder="结束日期" style="width: 100%"></el-date-picker>
      </el-form-item>
    </el-form>

    <el-row class="box">
      <el-col :span="4">发生日期</el-col>
      <el-col :span="4">报销类型</el-col>
      <el-col :span="6">所属项目</el-col>
      <el-col :span="4">报销金额</el-col>
      <el-col :span="2"><el-button style="margin-left: 20px" @click="addRows(1)">添加行</el-button></el-col>
    </el-row>

    <el-row v-for="item in busData.itemList" :key="item.id" class="row" :gutter="25">
      <el-col :span="4" class="tip">
        <el-date-picker v-model="item.date" type="date" style="width: 100%"></el-date-picker>
      </el-col>
      <el-col :span="4" class="tip">
        <el-input v-model="item.type" style="width: 100%"></el-input>
      </el-col>
      <el-col :span="6" class="tip">
        <el-input v-model="item.project_name" style="width: 100%"></el-input>
      </el-col>
      <el-col :span="4" class="tip">
        <el-input-number v-model="item.amount" style="width: 100%"></el-input-number>
      </el-col>
      <el-col :span="2">
        <div class="close" @click="removeRow(item.id)">
          <el-icon>
            <ElIconClose></ElIconClose>
          </el-icon>
        </div>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" style="width: 500px;;margin-top: 20px" @click="createRequest" :loading="loading">提交</el-button>
    </el-form-item>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "PrcTest1Create",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      busData: {
        start_date: '2024-12-01',
        end_date: '2024-12-31',
        itemList: [{id:'row1', date:'2024-12-07',type:'交通费',project_name:'YKK-MES',amount:100},
          {id:'row2', date:'2024-12-09',type:'餐费',project_name:'YKK-品质',amount:666},
          {id:'row3', date:'2024-12-15',type:'加班费',project_name:'YKK-无纸化',amount:200}]
      },
      loading: false
    }
  },
  created() {
    this.addRows(5)
  },
  methods: {
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()

    },
    clearPreData() {
      //清空表单数据
      this.busData.itemList = []
      this.addRows(5);
    },
    createRequest() {
      this.busData.chanceId = this.parentData.chance_id;
      this.loading = true;

      this.$http('testProcessService.createPrcTest1', this.busData).then(data => {
        this.loading = false;
        this.clearPreData();
        this.$fn.closeWindow();
      })
    },
    addRows(cnt) {
      for (let i = 0; i < cnt; i++) {
        this.busData.itemList.push({
          id: nanoid()
        })
      }
    },
    removeRow(id) {
      let index = this.busData.itemList.findIndex(item => item.id === id);
      this.busData.itemList.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>